import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"file-download, document"} maskId="square-filled-radius-0-stroke-1-IconFileDownload"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 2H4V22H20V9.5H12.5V2ZM12 19.9571L8.79289 16.75L9.5 16.0429L11.5 18.0429V12H12.5V18.0429L14.5 16.0429L15.2071 16.75L12 19.9571Z" fill="currentColor"/><path d="M13.5 2.29289L19.7071 8.5H13.5V2.29289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFileDownload;
